import React from 'react'
import { Tabs } from 'antd'
import TradePorModelo from './TradePorModelo'
import CiclosTab from './CiclosTab'

/**
 * Trade. El precio se fija SIEMPRE por modelo + año (conca) y baja solo a todos los colores.
 * Se quitó la actualización por material: era la que dejaba colores descuadrados.
 * El historial vive en los ciclos mensuales, que es como realmente se trabaja (carga del día 1).
 */
const TradeTab = ({ onChanged }) => (
  <Tabs
    defaultActiveKey="modelo"
    items={[
      { key: 'modelo', label: '1. Actualizar precio por modelo', children: <TradePorModelo onChanged={onChanged} /> },
      { key: 'ciclos', label: '2. Ciclos mensuales (historial)', children: <CiclosTab /> },
    ]}
  />
)

export default TradeTab
